import React, { useState } from 'react'
import cx from 'classnames'
import style from './tooltip.module.scss'
import PropTypes from 'prop-types'

const VegaTooltip = ({ className, label, children }) => {
	const [display, setDisplay] = useState(false)

	const onEnter = () => {
		setDisplay(true)
	}

	const onLeave = () => {
		setDisplay(false)
	}

	const onClick = () => {
		setDisplay(true)
		setTimeout(() => setDisplay(false), 3000)
	}

	return (
		<div
			className={cx(className, style.tooltip)}
			onMouseEnter={onEnter}
			onMouseLeave={onLeave}
			onClick={onClick}
		>
			{children}
			{display && <div className={style.label}>{label}</div>}
		</div>
	)
}

VegaTooltip.propTypes = {
	/** Allow to set a classname on the component */
	className: PropTypes.string,
	/** Label of the tooltip */
	label: PropTypes.string
}

export { VegaTooltip }
